(() => {
  'use strict';
  if (window.cbcLuxeInitialised) return;
  window.cbcLuxeInitialised = true;
  const closeSearch = (details, restoreFocus = false) => {
    if (!details) return;
    details.open = false;
    if (restoreFocus) details.querySelector(':scope > summary')?.focus();
  };
  const initialise = (root = document) => {
    root.querySelectorAll('[data-cbc-search]').forEach((details) => {
      if (details.dataset.cbcLuxeReady) return;
      details.dataset.cbcLuxeReady = 'true';
      const summary = details.querySelector(':scope > summary');
      summary?.setAttribute('aria-expanded', String(details.open));
      details.addEventListener('toggle', () => {
        summary?.setAttribute('aria-expanded', String(details.open));
        if (!details.open) return;
        document.querySelectorAll('[data-cbc-mobile][open], [data-cbc-details][open]').forEach((other) => { other.open = false; });
        const input = details.querySelector('input[type="search"]');
        requestAnimationFrame(() => { if (details.open) input?.focus({ preventScroll: true }); });
      });
      details.querySelector('[data-cbc-close-search]')?.addEventListener('click', () => closeSearch(details, true));
    });
    root.querySelectorAll('[data-cbc-mobile]').forEach((details) => {
      if (details.dataset.cbcLuxeReady) return;
      details.dataset.cbcLuxeReady = 'true';
      details.addEventListener('toggle', () => {
        if (details.open) document.querySelectorAll('[data-cbc-search][open]').forEach((search) => closeSearch(search));
      });
    });
  };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    document.querySelectorAll('[data-cbc-search][open]').forEach((details) => {
      if (!details.contains(event.target)) closeSearch(details);
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const search = document.querySelector('[data-cbc-search][open]');
    if (search) { closeSearch(search, true); event.preventDefault(); }
  });
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  document.addEventListener('shopify:section:unload', () => {
    document.querySelectorAll('[data-cbc-search][open]').forEach((details) => closeSearch(details));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  else initialise();
})();
